/**
 * Apoio das duas áreas da frente A5 (Financeiro e Sistema): data no formato do legado e a linha
 * compacta de campos. O que serve ao admin inteiro mora em `src/comum/` (moeda, confirmação, status
 * temporário, modal, rádio e copiar código); aqui fica só o que estas duas áreas usam.
 */

// O tipo do conteúdo de um componente.
import type { ReactNode } from 'react';

/**
 * Hoje no formato AAAA-MM-DD, como o legado calcula (`new Date().toISOString().slice(0, 10)`,
 * `admin.html:7235`, `7250` e `8419`). É a data em UTC: à noite no Brasil ela já é a de amanhã. É do
 * legado, reproduzido de propósito, e está registrado em PARIDADE-A5 para o fundador.
 */
export function hojeUTC(): string {
  return new Date().toISOString().slice(0, 10);
}

/** Data AAAA-MM-DD em DD/MM/AAAA, lida à meia-noite local para o fuso não voltar um dia (`admin.html:8396`). */
export function dataBR(dataIso: string): string {
  return new Date(dataIso + 'T00:00:00').toLocaleDateString('pt-BR');
}

/** Data e hora do banco em DD/MM/AAAA, como `new Date(x).toLocaleDateString('pt-BR')` do legado. */
export function dataHoraBR(iso: string): string {
  return new Date(iso).toLocaleDateString('pt-BR');
}

/** A linha compacta dos campos curtos relacionados, alinhada pelo pé (regra de formulário da casa). */
export function LinhaCompacta({ children }: { readonly children: ReactNode }) {
  return <div className="flex flex-wrap items-end gap-cx-3">{children}</div>;
}
